import { useRouter } from 'next/router'
import {
  EventActions,
  EventCategories,
  EventNames,
  sendDigitalDataEvent,
} from '@cinch-nx/shared-analytics'
import type { Site } from '@cinch-labs/sites-sdk'
import { track } from '@cinch-labs/customer-data-segment'
import { FullWidthCTA, FullWidthCTAProps } from '@cinch-labs/design-system'
import { datadogRum } from '@datadog/browser-rum'
import styles from './pre-footer-cta-v2-wrapper.module.css'

export interface PreFooterCtaV2WrapperProps extends FullWidthCTAProps {
  site?: Site
}

const aboutCollectionsSearchAllCarsClick = (siteOrganisationalUnit: string) => {
  const evt = {
    event: {
      name: EventNames.click,
      category: EventCategories.button,
      action: EventActions.navigate,
      label: 'collection location page search',
    },
  }

  sendDigitalDataEvent(evt)
  datadogRum.addAction('CollectionLocationSearchAllCarsClicked', {
    siteId: siteOrganisationalUnit,
  })
  track('Collection location page search all cars', evt)
}

export const PreFooterCtaV2Wrapper: React.FC<PreFooterCtaV2WrapperProps> = (
  props,
) => {
  const router = useRouter()

  const onClickHandler = () => {
    aboutCollectionsSearchAllCarsClick(
      props.site?.getFeatureAttribute('organisationalUnit') ?? '',
    )
    router.push('/used-cars')
  }

  return (
    <div className={styles.wrapper}>
      <FullWidthCTA {...props} onButtonClick={onClickHandler} />
    </div>
  )
}
